import React from 'react'
import { contactPara } from '../../utils/introductionData'
import { socialMedia } from '../../utils/socialMediaData'

const ContactContent = () => {
  return (
    <div className='conatactWrapper pt-5'>
        <h1 className='fs-2 fw-bolder text-body-tertiary'>Don't be shy !</h1>
        <p className='fs-5 text-secondary p-4'>{contactPara}</p>
        <div className='d-flex align-items-center justify-content-center'>
            <img src='mailIcon.png' alt='...' style={{ width: '40px' }}/>
            <p className='fs-5 text-secondary mb-0 ms-2'>aayushsrivastava9760@gmail.com</p>
        </div>
        <ul className='nav justify-content-center pt-4'>
            {
            socialMedia.map(media =>
                <li className='nav-item m-3'>
                <a href={media.url} target='_blank' rel="noopener noreferrer">
                    <img src={media.image} alt='...' />
                </a>
                </li>
            )
            }
        </ul>
    </div>
  )
}

export default ContactContent